import Component from 'vue-class-component';
import { Mixins } from 'vue-property-decorator';
import ResponsePdfDrawnMixin from '@/courses/mixins/response-pdf-draw.mixin';
import CourseWhiteboardResponseMixin from '@/courses/mixins/course-whiteboard-response.mixin';
@Component({})
export default class EdViewerResponseFileObject extends Mixins(ResponsePdfDrawnMixin, CourseWhiteboardResponseMixin) {

    mounted() {
        if(this.canSendFeedback){
            this.callPdf(this.homeworkId, this.student.id);
        }else{
            this.cancelLoading();
        }
    }
}